import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Indicators from "./Indicators";

import { selectEvents, selectPlanningCurrentDateRange } from "../../../redux/selectors/planningSelector";

class Header extends Component {
  render() {
    return (
      <Fragment>
        <Indicators {...this.props} />
      </Fragment>
    );
  }
}
const mapStateToProps = state => {
  return {
    events: selectEvents(state),
    currentDateRange: selectPlanningCurrentDateRange(state)
  };
};
export default connect(mapStateToProps, null)(Header);



// WEBPACK FOOTER //
// src/containers/activite/planning/Header.js